module.exports = __webpack_public_path__ + "img/white-search-icon.5b1194af.svg";